module.exports = __webpack_public_path__ + "static/media/fr.d72766e5.pdf";